export const getDigits = (value: string) => value.replace(/[^\d]/g, "");

export const formatCNPJ = (value: string) => value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
export const formatCPF = (value: string) => value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");

export const isCPF = (value: string) => value.length === 11;
export const isCNPJ = (value: string) => value.length === 14;

export const removeExcessiveDigits = (value: string, maxLength: number) => {
  if (value.length > maxLength) {
    return value.slice(0, maxLength);
  }
  return value;
};
